import {
  GAME_CASE_BATTLES_LIST,
  GAME_CASE_BATTLES_GET_ID,
  GAME_CASE_BATTLES_CREATE,
  GAME_CASE_BATTLES_JOIN,
  GAME_CASE_BATTLES_REQUEST_BOT,
} from '@/utils/constants/api-endpoints'
import socket from '@/plugins/socket'

export const get = () => socket.request(GAME_CASE_BATTLES_LIST)
export const getById = id => socket.request(GAME_CASE_BATTLES_GET_ID, id)
export const create = config => socket.request(GAME_CASE_BATTLES_CREATE, config)
export const join = form => socket.request(GAME_CASE_BATTLES_JOIN, form)
export const requestBot = form => socket.request(GAME_CASE_BATTLES_REQUEST_BOT, form)
